module.exports = __webpack_public_path__ + "img/credenciales-facebook.54afbe8c.svg";